// Vendor Libraries
import { ElementRef } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
// Services
import { GlossaryService } from 'GlossaryApp/ts/services/glossary.service';
import { UrlsService } from 'NewAngular/services/core/urls.service';
import * as i0 from "@angular/core";
import * as i1 from "NewAngular/services/core/urls.service";
import * as i2 from "GlossaryApp/ts/services/glossary.service";
import * as i3 from "@angular/platform-browser";
import * as i4 from "@angular/common";
import * as i5 from "../../../../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
import * as i6 from "../../../../../../../../search/static/search/ts/features/icon-search-autocomplete/icon-search-autocomplete.component";
function GlossaryTermComponent_div_1_span_22_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 24);
    i0.ɵɵtext(1, " (Draft)");
    i0.ɵɵelementEnd();
} }
function GlossaryTermComponent_div_1_p_23_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "p", 25);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("innerHtml", ctx_r1.term.definition, i0.ɵɵsanitizeHtml);
} }
function GlossaryTermComponent_div_1_div_24_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 26);
    i0.ɵɵtext(1, "Formula");
    i0.ɵɵelementEnd();
} }
function GlossaryTermComponent_div_1_p_25_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "p", 25);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("innerHtml", ctx_r1.term.formula, i0.ɵɵsanitizeHtml);
} }
function GlossaryTermComponent_div_1_div_26_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 26);
    i0.ɵɵtext(1, "Analysis Tutorial");
    i0.ɵɵelementEnd();
} }
function GlossaryTermComponent_div_1_div_27_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 27);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("innerHtml", ctx_r1.sanitizedVideoLink, i0.ɵɵsanitizeHtml);
} }
function GlossaryTermComponent_div_1_div_29_a_3_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 31);
    i0.ɵɵlistener("click", function GlossaryTermComponent_div_1_div_29_a_3_Template_a_click_0_listener() { const relatedTerm_r4 = i0.ɵɵrestoreView(_r3).$implicit; const ctx_r1 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r1.navigateToDefinitionPage(relatedTerm_r4.internalName)); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const relatedTerm_r4 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(relatedTerm_r4.name);
} }
function GlossaryTermComponent_div_1_div_29_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 28)(1, "strong", 29);
    i0.ɵɵtext(2, "Related Terms");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, GlossaryTermComponent_div_1_div_29_a_3_Template, 2, 1, "a", 30);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", ctx_r1.relatedTerms);
} }
function GlossaryTermComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 2)(1, "div", 3)(2, "div", 4)(3, "div", 5)(4, "div", 6)(5, "h1", 7);
    i0.ɵɵtext(6, "Financial Glossary");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(7, "div", 6)(8, "div", 8)(9, "label", 9);
    i0.ɵɵtext(10, "Search");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "ycn-icon-search-autocomplete", 10);
    i0.ɵɵlistener("submitHandler", function GlossaryTermComponent_div_1_Template_ycn_icon_search_autocomplete_submitHandler_11_listener($event) { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.navigateToDefinitionPage($event.search_id)); });
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(12, "div", 11)(13, "a", 12);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(14, "svg", 13);
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(15, "span", 14);
    i0.ɵɵtext(16, "View All Terms");
    i0.ɵɵelementEnd()()()()()();
    i0.ɵɵelementStart(17, "div", 15)(18, "div", 5)(19, "div", 16)(20, "h1", 17);
    i0.ɵɵtext(21);
    i0.ɵɵtemplate(22, GlossaryTermComponent_div_1_span_22_Template, 2, 0, "span", 18);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(23, GlossaryTermComponent_div_1_p_23_Template, 1, 1, "p", 19)(24, GlossaryTermComponent_div_1_div_24_Template, 2, 0, "div", 20)(25, GlossaryTermComponent_div_1_p_25_Template, 1, 1, "p", 19)(26, GlossaryTermComponent_div_1_div_26_Template, 2, 0, "div", 20)(27, GlossaryTermComponent_div_1_div_27_Template, 1, 1, "div", 21);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(28, "div", 22);
    i0.ɵɵtemplate(29, GlossaryTermComponent_div_1_div_29_Template, 4, 1, "div", 23);
    i0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(11);
    i0.ɵɵproperty("appendToBody", false)("placeholder", "Search Term")("searchType", "glossary_term");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("href", ctx_r1.glossaryHomeUrl, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", "icon-back");
    i0.ɵɵadvance(7);
    i0.ɵɵtextInterpolate(ctx_r1.term.name);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.term.status === "draft");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.term.definition);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.term.formula);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.term.formula);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.sanitizedVideoLink);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.sanitizedVideoLink);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.relatedTerms.length > 0);
} }
export class GlossaryTermComponent {
    constructor(eltRef, urlsService, glossaryService, sanitizer) {
        this.eltRef = eltRef;
        this.urlsService = urlsService;
        this.glossaryService = glossaryService;
        this.sanitizer = sanitizer;
        this.internalName = '';
        this.relatedTerms = [];
        this.sanitizedVideoLink = '';
        this.internalName = eltRef.nativeElement.getAttribute('internalName');
        this.glossaryHomeUrl = this.urlsService.GLOSSARY.GLOSSARY_HOME;
    }
    ngOnInit() {
        this.glossaryService.getGlossaryTermData(this.internalName).subscribe((data) => {
            this.term = data.term;
            this.relatedTerms = data.relatedTerms;
            if (this.term.videoLink) {
                this.sanitizedVideoLink = this.sanitizer.bypassSecurityTrustHtml(this.term.videoLink);
            }
        });
    }
    navigateToDefinitionPage(term) {
        if (term !== undefined) {
            window.location.href = this.urlsService.getUrl(this.urlsService.GLOSSARY.GLOSSARY_TERM, { term });
        }
    }
}
GlossaryTermComponent.ɵfac = function GlossaryTermComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || GlossaryTermComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i1.UrlsService), i0.ɵɵdirectiveInject(i2.GlossaryService), i0.ɵɵdirectiveInject(i3.DomSanitizer)); };
GlossaryTermComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: GlossaryTermComponent, selectors: [["ycn-glossary-term"]], standalone: false, decls: 2, vars: 1, consts: [[1, "page-content"], ["class", "page page-support", 4, "ngIf"], [1, "page", "page-support"], [1, "page-header", "page-header-support", "page-header-tall"], [1, "container"], [1, "row"], [1, "col-auto"], [1, "page-title"], [1, "form-inline"], [1, "form-label", "form-label-thin"], [3, "submitHandler", "appendToBody", "placeholder", "searchType"], [1, "col-12"], [1, "page-header-navigation-inline", 3, "href"], ["ycnIcon", "", 3, "name"], [1, "page-header-navigation-title"], [1, "glossary-article", "page-body", "container"], [1, "col-9"], [1, "glossary-title"], ["class", "text-blue", 4, "ngIf"], [3, "innerHtml", 4, "ngIf"], ["class", "glossary-subtitle", 4, "ngIf"], ["class", "video-responsive", 3, "innerHtml", 4, "ngIf"], [1, "col-3"], ["class", "glossary-sidebar", 4, "ngIf"], [1, "text-blue"], [3, "innerHtml"], [1, "glossary-subtitle"], [1, "video-responsive", 3, "innerHtml"], [1, "glossary-sidebar"], [1, "glossary-sidebar-title"], ["class", "glossary-sidebar-item", "href", "javascript:void(0)", 3, "click", 4, "ngFor", "ngForOf"], ["href", "javascript:void(0)", 1, "glossary-sidebar-item", 3, "click"]], template: function GlossaryTermComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "main", 0);
        i0.ɵɵtemplate(1, GlossaryTermComponent_div_1_Template, 30, 13, "div", 1);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.term);
    } }, dependencies: [i4.NgForOf, i4.NgIf, i5.IconDirective, i6.IconSearchAutocompleteComponent], encapsulation: 2 });
